module.exports = __webpack_public_path__ + "img/hot.8d1167d4.png";